<template>
  <svg :height="size" :width="size" fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      :stroke="color"
      d="M10.3548 17.7475V14.4444C10.3548 11.34 12.8948 8.80005 15.9996 8.80005C19.104 8.80005 21.644 11.34 21.644 14.4444V17.7475"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="2"
    />
    <path
      :fill="color"
      d="M24 29.6C24 25.6 20.1177 23.8801 16.0006 23.8801C11.8831 23.8801 8 25.6 8 29.6C8 29.6 9.02816 32 16.0006 32C22.9731 32 24 29.6 24 29.6Z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EdroneAvatarNShape",
  props: {
    size: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: "#545454",
    },
  },
});
</script>

<style scoped></style>
